module.exports = __webpack_public_path__ + "ce1233a32889ae26e740423d672b79a1.svg";